import { createContext, useContext, useState } from 'react'
import ApiService from '../ApiService'

const CarrommContext = createContext(null)

export const useCarromm = () => useContext(CarrommContext)

export const CarrommProvider = ({ children }) => {
  // const [holdUrl, setHoldUrl] = useState([]);
  const [showTable, setShowTable] = useState(false)
  const [holdFile, setHoldFile] = useState([])
  const [previewImages, setPreviewImages] = useState([])
  const [input, setInput] = useState([])
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)
  const [isLogin, setIsLogin] = useState( localStorage.getItem('user') || false)

  return (
    <CarrommContext.Provider
      value={{
        // holdUrl,
        // setHoldUrl,
        setShowTable,
        setIsButtonDisabled,
        isButtonDisabled,
        showTable,
        holdFile,
        setHoldFile,
        previewImages,
        setPreviewImages,
        input,
        setInput,
        isLogin,
        setIsLogin
      }}
    >
      {children}
    </CarrommContext.Provider>
  )
}

export const uploadImages = async bodyContent => {
  const response = await ApiService.post(
    '/automobile/background/replace',
    bodyContent
  )
  const data = await response.data
  return data
}
export const getImage = async skuId => {
  const response = await ApiService.get(
    `/automobile/background/replace?sku_id=${skuId}`
  )
  const data = await response.data
  return data
}
